
// import React, { useEffect, useState } from 'react';
// import {
//   Box, Button, TextField, Typography, Switch,
//   FormControlLabel, Paper, MenuItem, Select, InputLabel,
//   FormControl, Checkbox, ListItemText
// } from '@mui/material';
// import axios from './AxiosInstance';

// function NewDeviceJob() {
//   const [formData, setFormData] = useState({
//     descr: '',
//     targets: [],
//     status: 0,
//     active: true,
//     data: '',
//     expire: false
//   });

//   const [devices, setDevices] = useState([]);
//   const [serverResponse, setServerResponse] = useState({ error: '', message: '' });
//   const [errors, setErrors] = useState({
//     descr: '',
//     data: '',
//   });

//   useEffect(() => {
//     axios.get(`/recent`)
//       .then((res) => setDevices(res.data))
//       .catch(() => setDevices([]));
//   }, []);

//   const validateDescr = (value) => {
//     if (!value) return 'Description is required';
//     if (!/^[A-Z0-9 ]+$/.test(value)) return 'Only uppercase A-Z, numbers, and spaces allowed';
//     return '';
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name === 'descr') {
//       const upperValue = value.toUpperCase().replace(/[^A-Z0-9 ]/g, '');
//       const errMsg = validateDescr(upperValue);
//       setFormData((prev) => ({ ...prev, [name]: upperValue }));
//       setErrors((prev) => ({ ...prev, descr: errMsg }));
//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleTargetChange = (event) => {
//     const {
//       target: { value },
//     } = event;
//     setFormData((prev) => ({
//       ...prev,
//       targets: typeof value === 'string' ? value.split(',') : value,
//     }));
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file && file.type === "application/json") {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         try {
//           const json = JSON.parse(event.target.result);
//           setFormData((prev) => ({
//             ...prev,
//             data: JSON.stringify(json),
//           }));
//           setErrors(prev => ({ ...prev, data: '' }));
//         } catch (err) {
//           alert("Invalid JSON file.");
//           setErrors(prev => ({ ...prev, data: 'Invalid JSON file' }));
//           setFormData(prev => ({ ...prev, data: '' }));
//         }
//       };
//       reader.readAsText(file);
//     } else {
//       alert("Please upload a valid .json file.");
//       setErrors(prev => ({ ...prev, data: 'Please upload a valid .json file' }));
//       setFormData(prev => ({ ...prev, data: '' }));
//     }
//   };

//   const handleSubmit = async () => {
//     const descrError = validateDescr(formData.descr);
//     if (descrError) {
//       setErrors(prev => ({ ...prev, descr: descrError }));
//       return;
//     }

//     if (!formData.data) {
//       setErrors(prev => ({ ...prev, data: 'JSON data is required' }));
//       return;
//     }

//     if (errors.data) {
//       return;
//     }

//     try {
//       const response = await axios.post('/device-jobs', formData);
//       setServerResponse({ error: '', message: response.data.message || 'Job submitted successfully.' });
//     } catch (error) {
//       setServerResponse({ error: 'Error submitting job', message: '' });
//     }
//   };

//   return (
//     <Paper sx={{ p: 4, maxWidth: 600, margin: 'auto', mt: 4 }}>
//       <Typography variant="h6" gutterBottom>New Device Job</Typography>

//       <TextField
//         label="Description"
//         name="descr"
//         fullWidth
//         margin="normal"
//         value={formData.descr}
//         onChange={handleChange}
//         error={!!errors.descr}
//         helperText={errors.descr}
//       />

//       <FormControl fullWidth margin="normal">
//         <InputLabel id="targets-label">Target Devices</InputLabel>
//         <Select
//           labelId="targets-label"
//           multiple
//           value={formData.targets}
//           onChange={handleTargetChange}
//           renderValue={(selected) =>
//             selected.map((id) => devices.find((d) => d.id === id)?.name || id).join(', ')
//           }
//         >
//           {devices.map((device) => (
//             <MenuItem key={device.id} value={device.id}>
//               <Checkbox checked={formData.targets.indexOf(device.id) > -1} />
//               <ListItemText primary={device.name} />
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>

//       {/* <TextField
//         label="Status"
//         name="status"
//         type="number"
//         fullWidth
//         margin="normal"
//         value={formData.status}
//         onChange={handleChange}
//       /> */}

//       <Box mt={2}>
//         <Button variant="contained" component="label">
//           Upload JSON File
//           <input
//             type="file"
//             accept=".json"
//             hidden
//             onChange={handleFileUpload}
//           />
//         </Button>
//         {errors.data && (
//           <Typography color="error" variant="body2" sx={{ mt: 1 }}>
//             {errors.data}
//           </Typography>
//         )}
//       </Box>

//       {formData.data && (
//         <TextField
//           label="Uploaded JSON"
//           multiline
//           rows={6}
//           fullWidth
//           margin="normal"
//           value={
//             (() => {
//               try {
//                 const parsed = JSON.parse(formData.data);
//                 return JSON.stringify(parsed, null, 2);
//               } catch {
//                 return formData.data;
//               }
//             })()
//           }
//           InputProps={{ readOnly: true }}
//           variant="outlined"
//           sx={{ fontFamily: 'monospace' }}
//         />
//       )}
// {/* 
//       <FormControlLabel
//         control={<Switch checked={formData.active} onChange={handleChange} name="active" />}
//         label="Active"
//       /> */}

//       <FormControlLabel
//         control={<Switch checked={formData.expire} onChange={handleChange} name="expire" />}
//         label="Expire"
//       />

//       <Box mt={2}>
//         <Button 
//           variant="contained" 
//           onClick={handleSubmit} 
//           disabled={!!errors.descr || !!errors.data || !formData.data}
//         >
//           Submit Job
//         </Button>
//       </Box>

//       {/* Display message or error */}
//       {serverResponse.error ? (
//         <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
//           {serverResponse.error}
//         </Typography>
//       ) : (
//         serverResponse.message && (
//           <Typography color="success.main" sx={{ mt: 2, textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}>
//             {serverResponse.message}
//           </Typography>
//         )
//       )}
//     </Paper>
//   );
// }

// export default NewDeviceJob;
import React, { useEffect, useState } from 'react';
import {
  Box, Button, TextField, Typography, Switch,
  FormControlLabel, Paper, MenuItem, Select, InputLabel,
  FormControl, Checkbox, ListItemText
} from '@mui/material';
import axios from './AxiosInstance';

function NewDeviceJob() {
  const [formData, setFormData] = useState({
    descr: '',
    targets: [],
    status: 0,
    active: true,
    data: '',
    expire: false
  });

  const [devices, setDevices] = useState([]);
  const [serverResponse, setServerResponse] = useState({ error: '', message: '' });
  const [errors, setErrors] = useState({
    descr: '',
    data: '',
  });

  useEffect(() => {
    axios.get(`/api/recent`)
      .then((res) => setDevices(res.data))
      .catch(() => setDevices([]));
  }, []);

  const validateDescr = (value) => {
    if (!value) return 'Description is required';
    if (!/^[A-Z0-9 ]+$/.test(value)) return 'Only uppercase A-Z, numbers, and spaces allowed';
    return '';
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'descr') {
      const upperValue = value.toUpperCase().replace(/[^A-Z0-9 ]/g, '');
      const errMsg = validateDescr(upperValue);
      setFormData((prev) => ({ ...prev, [name]: upperValue }));
      setErrors((prev) => ({ ...prev, descr: errMsg }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleTargetChange = (event) => {
    const {
      target: { value },
    } = event;

    const selectedTargets = typeof value === 'string' ? value.split(',') : value;

    setFormData((prev) => ({
      ...prev,
      targets: selectedTargets,
      expire: selectedTargets.length > 0 ? prev.expire : false, // Reset expire if no targets
    }));
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/json") {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const json = JSON.parse(event.target.result);
          setFormData((prev) => ({
            ...prev,
            data: JSON.stringify(json),
          }));
          setErrors(prev => ({ ...prev, data: '' }));
        } catch (err) {
          alert("Invalid JSON file.");
          setErrors(prev => ({ ...prev, data: 'Invalid JSON file' }));
          setFormData(prev => ({ ...prev, data: '' }));
        }
      };
      reader.readAsText(file);
    } else {
      alert("Please upload a valid .json file.");
      setErrors(prev => ({ ...prev, data: 'Please upload a valid .json file' }));
      setFormData(prev => ({ ...prev, data: '' }));
    }
  };

  const handleSubmit = async () => {
    const descrError = validateDescr(formData.descr);
    if (descrError) {
      setErrors(prev => ({ ...prev, descr: descrError }));
      return;
    }

    if (!formData.data) {
      setErrors(prev => ({ ...prev, data: 'JSON data is required' }));
      return;
    }

    if (errors.data) {
      return;
    }

    try {
      const response = await axios.post('/api/device-jobs', formData);
      setServerResponse({ error: '', message: response.data.message || 'Job submitted successfully.' });
    } catch (error) {
      setServerResponse({ error: 'Error submitting job', message: '' });
    }
  };

  return (
    <Paper sx={{ p: 4, maxWidth: 600, margin: 'auto', mt: 4 }}>
      <Typography variant="h6" gutterBottom>New Device Job</Typography>

      <TextField
        label="Description"
        name="descr"
        fullWidth
        margin="normal"
        value={formData.descr}
        onChange={handleChange}
        error={!!errors.descr}
        helperText={errors.descr}
      />

      <FormControl fullWidth margin="normal">
        <InputLabel id="targets-label">Target Devices</InputLabel>
        <Select
          labelId="targets-label"
          multiple
          value={formData.targets}
          onChange={handleTargetChange}
          renderValue={(selected) =>
            selected.map((id) => devices.find((d) => d.id === id)?.name || id).join(', ')
          }
        >
          {devices.map((device) => (
            <MenuItem key={device.id} value={device.id}>
              <Checkbox checked={formData.targets.indexOf(device.id) > -1} />
              <ListItemText primary={device.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box mt={2}>
        <Button variant="contained" component="label">
          Upload JSON File
          <input
            type="file"
            accept=".json"
            hidden
            onChange={handleFileUpload}
          />
        </Button>
        {errors.data && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {errors.data}
          </Typography>
        )}
      </Box>

      {formData.data && (
        <TextField
          label="Uploaded JSON"
          multiline
          rows={6}
          fullWidth
          margin="normal"
          value={
            (() => {
              try {
                const parsed = JSON.parse(formData.data);
                return JSON.stringify(parsed, null, 2);
              } catch {
                return formData.data;
              }
            })()
          }
          InputProps={{ readOnly: true }}
          variant="outlined"
          sx={{ fontFamily: 'monospace' }}
        />
      )}

      {/* Show expire switch only if targets are selected */}
      {formData.targets.length > 0 && (
        <FormControlLabel
          control={<Switch checked={formData.expire} onChange={handleChange} name="expire" />}
          label="Expire"
        />
      )}

      <Box mt={2}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!!errors.descr || !!errors.data || !formData.data}
        >
          Submit Job
        </Button>
      </Box>

      {serverResponse.error ? (
        <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
          {serverResponse.error}
        </Typography>
      ) : (
        serverResponse.message && (
          <Typography color="success.main" sx={{ mt: 2, textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}>
            {serverResponse.message}
          </Typography>
        )
      )}
    </Paper>
  );
}

export default NewDeviceJob;
